import './year-list-cta.scss';

/**
 * version    1.0
 * class      <type> (YearListCta)
 * classdesc  Component that manage YearListCta
 */
export class YearListCta {}
